import { cookie } from '@tencent/qd-lib';

let isLocalStorageSupported = true;
try {
  localStorage.setItem('test-qd-localStorage', '1');
} catch (ex) {
  isLocalStorageSupported = false;
};
// 首选localStorage作为存储对象，不然就用cookie兼容
export const myLocalStorage = {
  getItem: (item) => {
    try {
      if (isLocalStorageSupported) {
        return localStorage.getItem(item);
      };
      return cookie.get(item);
    } catch (ex) {
      return '';
    }
  },
  setItem: (item, value) => {
    try {
      if (isLocalStorageSupported) {
        return localStorage.setItem(item, value);
      };
      return cookie.set(item, value, {
        expires: 365,
      });
    } catch (ex) {
      return '';
    }
  },
  removeItem: (item) => {
    try {
      if (isLocalStorageSupported) {
        return localStorage.removeItem(item);
      };
      return cookie.remove(item);
    } catch (ex) {
      return '';
    }
  },
};
